import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, CircularProgress } from '@mui/material';
import { Veiculo } from '../../types/frota';
import frotaService from '../../services/frotaService';

interface VeiculoSelectProps {
  value?: number | null;
  onChange: (value: number | null) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  apenasAtivos?: boolean;
}

const VeiculoSelect: React.FC<VeiculoSelectProps> = ({
  value = null,
  onChange,
  label = 'Veículo',
  required = false,
  disabled = false,
  error = false,
  helperText,
  size = 'medium',
  fullWidth = true,
  apenasAtivos = true,
}) => {
  const [veiculos, setVeiculos] = useState<Veiculo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadVeiculos();
  }, []);

  const loadVeiculos = async () => {
    try {
      setLoading(true);
      const response = await frotaService.listarVeiculos({ limit: 500, status: apenasAtivos ? 'ativo' : '' });
      setVeiculos(response.data || []);
    } catch {
      setVeiculos([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <FormControl fullWidth={fullWidth} size={size}>
        <CircularProgress size={24} />
      </FormControl>
    );
  }

  return (
    <FormControl fullWidth={fullWidth} size={size} required={required} error={error} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        size="small"
        value={value ?? ''}
        label={label}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      >
        <MenuItem value=""><em>Selecione</em></MenuItem>
        {veiculos.map((v) => (
          <MenuItem key={v.id} value={v.id}>
            {v.placa} - {v.marca} {v.modelo}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default VeiculoSelect;
